import { Component, Input } from '@angular/core';
import { ChallengeContextService } from '../../shared/contexts/challenge-context/challenge-context.service';

@Component({selector:'app-central-profile-context',template:`
<ng-template appCentralChildNav><nav class="central-context-row" aria-label="Profile location">
  <a [routerLink]="kind === 'team' ? '/streaker-central/teams' : '/streaker-central/streakers'" [queryParams]="{view:null,tab:null,challengeId:context.currentChallenge?.ChallengeDefinitionId || null}" queryParamsHandling="merge"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ kind === 'team' ? 'All teams' : 'All streakers' }}</a>
  <span class="context-separator" aria-hidden="true">/</span><span class="context-name" aria-current="page">{{ name || (kind === 'team' ? 'Team profile' : 'Streaker profile') }}</span>
</nav></ng-template>`})
export class CentralProfileContextComponent {
    constructor(public context:ChallengeContextService){}
    @Input() kind:'streaker'|'team'='streaker';
    @Input() name='';
}
